// ----------------------------------------------------------------------

export default function Tabs(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
          '&.Mui-selected': {
            color: theme.palette.text.primary,
          },
          '&:not(:last-of-type)': {
            // marginRight: theme.spacing(5),
          },
          '@media (min-width: 600px)': {
            minWidth: 48,
          },
        },
        labelIcon: {
          minHeight: 48,
          flexDirection: 'row',
          '& > *:first-of-type': {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: 'row',
          whiteSpace: 'nowrap',
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 48,
          borderRadius: '50%',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          background: "rgba(30, 30, 40, 0.3)", /* Balanced darkness */
          backdropFilter: "blur(20px) !important", // Strong blur for iOS glass effect
          "-webkit-backdrop-filter": "blur(20px) !important", // Safari support
          borderRadius: theme.shape.borderRadius, // Match your theme
        },
      },
    },
  };
}
